import { SiemProtocol } from '@kirin/api-client/contracts/settings';

export const siemProtocolLabelMap: Record<SiemProtocol, string> = {
  [SiemProtocol.Tcp]: 'TCP',
  [SiemProtocol.Udp]: 'UDP',
  [SiemProtocol.Hec]: 'HEC',
};

export const siemProtocolDefaultPort: Record<SiemProtocol, number> = {
  [SiemProtocol.Tcp]: 6514,
  [SiemProtocol.Udp]: 514,
  // Splunk HEC's default collector port. HEC configs use a full endpoint URL
  // rather than host/port, so this is informational until the HEC form lands
  // (KIR-4032).
  [SiemProtocol.Hec]: 8088,
};
